module.exports = __webpack_public_path__ + "media/country_flags/gg-0fb9f32c.png";